import Vue from 'vue';
import VueI18n from 'vue-i18n';
// load locales
import en from '@/i18n/locale/en.json';
import se from '@/i18n/locale/se.json';
import no from '@/i18n/locale/no.json';

import toLower from 'lodash';
// register i18n module
Vue.use(VueI18n);

// define regional datetime formats
const dateTimeFormats = {
  'en': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  'se': {
    short: {
      day: '2-digit', month: '2-digit', year: '2-digit'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  'no': {
    short: {
      day: '2-digit', month: '2-digit', year: '2-digit'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  }
};

// add new locales to this map
const messages = {
  en,
  se,
  no
};

const resolveLocale = (locale: string) => {
  let lang = locale === 'no' || locale === 'nb' ? 'no' : 'en';
  return lang;
};

// Make VueI18n instance
const i18n = new VueI18n({
  locale: resolveLocale(window.navigator.language),
  messages,
  dateTimeFormats
});

/**
 * Translate Text
 * @param key
 */
const translate = (key: string) => {
  if (!key) {
    return '';
  }
  return i18n.t(key);
};

/**
 * Translate Date
 * @param date
 */
const translateDate = (date: Date) => {
  if (!date) {
    return '';
  }
  return i18n.d(date, 'short');
};

/**
 * Get Datepicker compatible locale for current setting
 */
const datepickerLocale = () => {
  let lang = '';
  switch (i18n.locale) {
    case 'no':
      lang = 'nb-no';
      break;
    case 'se':
      lang = 'sv-se';
      break;
    default:
      lang = 'en';
  }
  return lang;
};

export { i18n, resolveLocale, translate, translateDate, datepickerLocale };
